export type LanguageList = { code: string, description: string }[];

export const langList: LanguageList = [
    { code: "en", description: "English" },
    { code: "de", description: "Deutsch" }
];
